import { forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

/**
 * Form label that pairs with Input/Select via htmlFor. Mono caption font to
 * stay consistent with field-meta typography across the app.
 */
export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        'font-mono text-caption text-text-secondary',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
